import React from 'react';
import { reduxForm } from 'redux-form';
import { func } from 'prop-types';

import UTForm from 'app/components/UTForm';
import { TURN_USER_INFORMATION } from 'constants/reduxForms';

import { fieldsArray } from './constants';

const UserInformationForm = ({ handleSubmit }) => (
  <form onSubmit={handleSubmit}>
    <UTForm fields={fieldsArray} />
  </form>
);

UserInformationForm.propTypes = {
  handleSubmit: func
};

export default reduxForm({ form: TURN_USER_INFORMATION })(UserInformationForm);
